import React from "react";
import cx from "classnames";

import { ViewerMode } from "src/types/experiences/storyboardSettings/storyboard";

import Card from "../card";
import RadioOption from "../radioOption";
import { useDraft } from "../useDraft";
import { canEdit } from "src/pages/experiences/storyboardSettings/utils/permissions";
import styles from "./assetViewerCard.module.scss";

interface Option {
  value: ViewerMode;
  title: string;
  description: string;
  icon: string;
}

const OPTIONS: Option[] = [
  {
    value: "BINGE",
    title: "Binge",
    description: "View assets in a stream — best for showcases",
    icon: "paperflite-binge",
  },
  {
    value: "LIGHTBOX",
    title: "Lightbox",
    description: "Assets open in a modal — best for catalogs",
    icon: "paperflite-lightbox",
  },
];

const AssetViewerCard: React.FC = () => {
  const { draft, setField } = useDraft();
  const selected = draft?.viewer ?? "BINGE";
  const darkViewer = Boolean(draft?.darkViewer);
  const editable = canEdit(draft?.role);

  const pickViewer = (value: ViewerMode) => {
    if (!editable) return;
    setField("viewer", value);
    if (value === "BINGE") setField("darkViewer", false);
  };

  const pickTheme = (value: boolean) => {
    if (!editable) return;
    setField("darkViewer", value);
  };

  return (
    <Card
      title="Asset Viewer Trigger"
      description="Choose Lightbox for a pop-up view or Binge for continuous scrolling"
    >
      <div className={cx(styles.list, !editable && styles.disabled)}>
        {OPTIONS.map((opt) => (
          <RadioOption
            key={opt.value}
            selected={selected === opt.value}
            darkViewer={darkViewer}
            label={opt.title}
            description={opt.description}
            value={opt.value}
            onSelect={() => pickViewer(opt.value)}
            onThemeChange={pickTheme}
          />
        ))}
      </div>
    </Card>
  );
};

export default AssetViewerCard;
